import {history} from "../../_helpers";
import {Auth} from "aws-amplify";

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
    Auth.signOut();
}

export const handleResponse = (response) => {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                window.location.reload(true);
            }

            if (response.status === 403) {                
                alert('You are not authorized to perform this action.');                
            }

            if (response.status === 409) {
                history.push('/feature-disabled');
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}
